import React from "react";
import { useReveal } from "../../hooks/useReveal";

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      className={`reveal ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default Reveal;
